import React, { useState, useEffect } from 'react';
import API from '../api/api';

export default function Expenses({ partnership, partners }) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const [form, setForm] = useState({ name: '', quantity: 1, price: '', payer_id: '', exempt_ids: [], date: new Date().toISOString().split('T')[0] });
  const [confirm, setConfirm] = useState(null);

  useEffect(() => { load(); }, [partnership.id]);

  const load = async () => {
    setLoading(true);
    const res = await API.get(`/detail-expenses/${partnership.id}/`);
    setData(res.data.expenses || []);
    setLoading(false);
  };

  const save = async (e) => {
    e.preventDefault();
    if (editItem) {
      await API.post(`/detail-expenses/${partnership.id}/`, { action: 'edit_expense', id: editItem.id, ...form });
    } else {
      await API.post(`/detail-expenses/${partnership.id}/`, form);
    }
    setShowForm(false); setEditItem(null);
    setForm({ name: '', quantity: 1, price: '', payer_id: '', exempt_ids: [], date: new Date().toISOString().split('T')[0] });
    load();
  };

  const doDelete = async () => {
    await API.post(`/detail-expenses/${partnership.id}/`, { action: 'delete_expense', id: confirm });
    setConfirm(null); load();
  };

  const startEdit = (exp) => {
    setEditItem(exp);
    setForm({ name: exp.name, quantity: exp.qty, price: exp.price, payer_id: exp.payer_id || '', exempt_ids: exp.exempt_ids || [], date: exp.date || '' });
    setShowForm(true);
  };

  const toggleExempt = (id) => {
    setForm(f => ({
      ...f,
      exempt_ids: f.exempt_ids.includes(id) ? f.exempt_ids.filter(x => x !== id) : [...f.exempt_ids, id]
    }));
  };

  const totalAll = data.reduce((s, e) => s + e.total, 0);
  const inp = { width: '100%', padding: '7px', border: '1px solid #ddd', borderRadius: '5px', boxSizing: 'border-box', fontSize: '13px' };
  const lbl = { display: 'block', fontSize: '12px', fontWeight: 'bold', marginBottom: '4px' };
  const btn = (bg) => ({ padding: '7px 16px', background: bg, color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer', fontSize: '13px', fontWeight: 'bold' });

  if (loading) return <div style={{ textAlign: 'center', padding: '30px' }}>جار التحميل...</div>;

  return (
    <div style={{ padding: '15px' }} dir="rtl">
      {/* تأكيد الحذف */}
      {confirm && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ background: 'white', padding: '25px', borderRadius: '10px', textAlign: 'center', minWidth: '280px' }}>
            <div style={{ fontSize: '40px', marginBottom: '10px' }}>⚠️</div>
            <p style={{ fontWeight: 'bold', marginBottom: '20px' }}>هل أنت متأكد من حذف هذا المصروف؟</p>
            <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
              <button onClick={doDelete} style={btn('#e74c3c')}>نعم، احذف</button>
              <button onClick={() => setConfirm(null)} style={btn('#95a5a6')}>إلغاء</button>
            </div>
          </div>
        </div>
      )}

      {/* هيدر */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
        <h3 style={{ margin: 0, color: '#1e3a5f' }}>💰 المصروفات</h3>
        <button onClick={() => { setShowForm(true); setEditItem(null); setForm({ name: '', quantity: 1, price: '', payer_id: '', exempt_ids: [], date: new Date().toISOString().split('T')[0] }); }} style={btn('#1e3a5f')}>+ مصروف جديد</button>
      </div>

      {/* ملخص */}
      <div style={{ background: 'white', padding: '12px', borderRadius: '8px', marginBottom: '15px', boxShadow: '0 1px 4px rgba(0,0,0,0.08)', display: 'flex', gap: '20px' }}>
        <div><span style={{ fontSize: '12px', color: '#666' }}>إجمالي المصروفات</span><br /><strong style={{ color: '#e74c3c', fontSize: '18px' }}>{totalAll.toLocaleString('ar-SA', {useGrouping:false, maximumFractionDigits: 2})} ر.س</strong></div>
        <div><span style={{ fontSize: '12px', color: '#666' }}>عدد المصروفات</span><br /><strong style={{ fontSize: '18px' }}>{data.length}</strong></div>
      </div>

      {/* نموذج */}
      {showForm && (
        <form onSubmit={save} style={{ background: 'white', padding: '15px', borderRadius: '8px', marginBottom: '15px', boxShadow: '0 1px 6px rgba(0,0,0,0.1)' }}>
          <h4 style={{ margin: '0 0 12px' }}>{editItem ? '✏️ تعديل مصروف' : '➕ مصروف جديد'}</h4>
          <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr 1fr', gap: '10px', marginBottom: '10px' }}>
            <div><label style={lbl}>اسم المصروف</label><input style={inp} value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} required /></div>
            <div><label style={lbl}>الكمية</label><input type="number" step="0.5" style={inp} value={form.quantity} onChange={e => setForm({ ...form, quantity: e.target.value })} /></div>
            <div><label style={lbl}>السعر</label><input type="number" step="0.01" style={inp} value={form.price} onChange={e => setForm({ ...form, price: e.target.value })} required /></div>
            <div>
              <label style={lbl}>الشراء بواسطة</label>
              <select style={inp} value={form.payer_id} onChange={e => setForm({ ...form, payer_id: e.target.value })}>
                <option value="">-- اختر --</option>
                {partners.map(p => <option key={p.id} value={p.id}>{p.name}</option>)}
              </select>
            </div>
            <div>
              <label style={lbl}>التاريخ</label>
              <input type="date" style={inp} value={form.date} onChange={e => setForm({ ...form, date: e.target.value })} />
            </div>
          </div>
          <div style={{ marginBottom: '10px' }}>
            <label style={lbl}>المعفيون من هذا المصروف</label>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
              {partners.map(p => (
                <label key={p.id} style={{ display: 'flex', alignItems: 'center', gap: '4px', cursor: 'pointer', background: form.exempt_ids.includes(p.id) ? '#ffeaa7' : '#f5f5f5', padding: '4px 10px', borderRadius: '15px', fontSize: '13px' }}>
                  <input type="checkbox" checked={form.exempt_ids.includes(p.id)} onChange={() => toggleExempt(p.id)} />
                  {p.name}
                </label>
              ))}
            </div>
          </div>
          <div style={{ display: 'flex', gap: '8px' }}>
            <button type="submit" style={btn('#27ae60')}>حفظ</button>
            <button type="button" onClick={() => { setShowForm(false); setEditItem(null); }} style={btn('#e74c3c')}>إلغاء</button>
          </div>
        </form>
      )}

      {/* الجدول */}
      <div style={{ overflowX: 'auto', boxShadow: '0 2px 8px rgba(0,0,0,0.08)', borderRadius: '8px' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', background: 'white' }}>
          <thead style={{position:'sticky',top:0,zIndex:10}}>
            <tr style={{ background: '#1e3a5f', color: 'white' }}>
              {['#', 'التاريخ', 'المصروف', 'الكمية', 'السعر', 'الإجمالي', 'الشراء بواسطة', 'معفى من المصروف', ''].map(h => (
                <th key={h} style={{ padding: '10px 8px', fontSize: '12px', textAlign: 'right' }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((e, i) => (
              <tr key={e.id} style={{ background: i % 2 === 0 ? 'white' : '#f8f9fa', borderBottom: '1px solid #eee' }}>
                <td style={{ padding: '9px 8px', fontSize: '13px', fontWeight: 'bold' }}>{i + 1}</td>
                <td style={{ padding: '9px 8px', fontSize: '13px', color: '#1565c0', fontWeight: 'bold' }}>{e.date || '—'}</td>
                <td style={{ padding: '9px 8px', fontSize: '13px', fontWeight: 'bold' }}>{e.name}</td>
                <td style={{ padding: '9px 8px', fontSize: '13px' }}>{e.qty}</td>
                <td style={{ padding: '9px 8px', fontSize: '13px' }}>{e.price.toLocaleString('ar-SA', {useGrouping:false, maximumFractionDigits: 2})}</td>
                <td style={{ padding: '9px 8px', fontSize: '13px', fontWeight: 'bold', color: '#e74c3c' }}>{e.total.toLocaleString('ar-SA', {useGrouping:false, maximumFractionDigits: 2})} ر.س</td>
                <td style={{ padding: '9px 8px', fontSize: '13px' }}>{e.payer_name || '—'}</td>
                <td style={{ padding: '9px 8px', fontSize: '12px', color: '#8e44ad' }}>
                  {e.exempt_names && e.exempt_names.length > 0 ? e.exempt_names.join('، ') : '—'}
                </td>
                <td style={{ padding: '9px 8px', whiteSpace: 'nowrap' }}>
                  <button onClick={() => startEdit(e)} style={{ padding: '4px 10px', background: '#f39c12', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '12px', marginLeft: '5px' }}>✏️</button>
                  <button onClick={() => setConfirm(e.id)} style={{ padding: '4px 10px', background: '#e74c3c', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '12px' }}>🗑️</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
